module.exports = __webpack_public_path__ + "img/cockpit.184cd3be.svg";